/* eslint-disable consistent-return */
// import hash from 'object-hash'
import { apiPaths, getApiPath, httpStatus } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

// -- GET (array of objects)
// export const GET_FLOW_CONDITIONS_SUCCESS = 'GET_FLOW_CONDITIONS_SUCCESS'
// export const GET_FLOW_CONDITIONS_FAILURE = 'GET_FLOW_CONDITIONS_FAILURE'

// -- UPDATE
export const UPDATE_FLOW_CONDITION_SUCCESS = 'UPDATE_FLOW_CONDITION_SUCCESS'
export const UPDATE_FLOW_CONDITION_FAILURE = 'UPDATE_FLOW_CONDITION_FAILURE'

// ____________________________________________________________

/**
 * Get the flow condition form the API and broadcast two types of events:
 * - GET_FLOW_CONDITIONS_SUCCESS: in case of success.
 * - GET_FLOW_CONDITIONS_FAILURE: in case of failure.
 *
 * @param {uuid} pid Project Id number
 * @param {uuid} sid Scenario Id number
 * @param {uuid} fid FlowGroup Id UUID
 * @param {boolean} noCache if true reset cache.
 * @returns {Promise<object>}
 */
// let _cacheItems = []
// const _getCacheKey = (pid, sid, fid) => {
//   return hash({ pid, sid, fid })
// }
// const _getCacheItem = (pid, sid, fid) => {
//   return _cacheItems[_getCacheKey(pid, sid, fid)]
// }
// const _pushCacheItem = (pid, sid, fid, item) => {
//   _cacheItems[_getCacheKey(pid, sid, fid)] = item
// }

// export const getFlowConditions = (pid, sid, fid, noCache) => async (dispatch) => {
//   // const key = hash({ pid, sid, fid })
//   // let result = null
//   let result = _getCacheItem(pid, sid, fid)

//   if (!result || noCache === true) {
//     const path = getApiPath(apiPaths.FLOW_CONDITION_LIST, { pid, sid, fid })
//     const api = new Api(path)
//     result = await api.get()
//     // _cacheItems[key] = result
//     _pushCacheItem(pid, sid, fid, result)
//     Logger.trace(LoggerTypes.ACTION, '[ACTION] flowConditionsActions.getFlowConditions(INIT)', {
//       path,
//       _cacheItems,
//       noCache
//     })
//   } else {
//     // result = _cacheItems[key]
//     Logger.trace(LoggerTypes.ACTION, '[ACTION] flowConditionsActions.getFlowConditions(CACHE)', {
//       _cacheItems,
//       noCache
//     })
//   }

//   if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
//     return dispatch({
//       type: GET_FLOW_CONDITIONS_SUCCESS,
//       data: result.data.items || []
//     })
//   }
//   return dispatch({
//     type: GET_FLOW_CONDITIONS_FAILURE,
//     data: result.data
//   })
// }

/**
 * Update the values of a flowCondition broadcast two types of events:
 * - UPDATE_FLOW_CONDITION_SUCCESS: in case of success.
 * - UPDATE_FLOW_CONDITION_FAILURE: in case of failure.
 *
 * @param {uuid} pid Project Id UUID
 * @param {uuid} sid Scenario Id UUID
 * @param {uuid} fid FlowGroup Id UUID
 * @param {object} flowCondition Flow condition to update (must contain `id` UUID attribute)
 * @returns {Promise<object>}
 */
export const updateFlowCondition = (pid, sid, fid, flowCondition) => async (dispatch) => {
  if (!flowCondition) {
    return
  }

  const path = getApiPath(apiPaths.FLOW_CONDITION_UPDATE, { pid, sid, fid, cid: flowCondition.id })
  const api = new Api(path)
  const result = await api.update(flowCondition)
  // _pushCacheItem(pid, sid, fid, result)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] flowConditionsActions.updateFlowCondition()', {
    path,
    result,
    flowCondition
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_FLOW_CONDITION_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_FLOW_CONDITION_FAILURE,
    data: result.data
  })
}
